import Navigation from 'Components/Page/Navigation';

const goToStrava = () =>
{
    if ( !process.env.REACT_APP_STRAVA_URL || process.env.REACT_APP_STRAVA_URL.trim ().length === 0 )
    {
        alert ( "Strava integration is not supported in this environment" );
    }
    else
    {
        window.location.href = process.env.REACT_APP_STRAVA_URL;
    }
}

function Strava () 
{
    return  <>
                <h1>Link your Strava Account</h1>
                <p>Click through and authenticate our challenge app with your Strava account to automatically feed your distance to the challenge leaderboards.</p>
                <button onClick={ () => goToStrava () }>Go To Strava</button>
                <Navigation />
            </>
}

export default Strava;
